import { render, staticRenderFns } from "./BlockType19.vue?vue&type=template&id=2b43253a"
import script from "./BlockType19.vue?vue&type=script&lang=ts"
export * from "./BlockType19.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports